import api from '../_api'
import { service as billingPrimaryService } from '@/api/billing-primary'
import {
    FETCH_SUMMARY_REQUEST,
    FETCH_SUMMARY_SUCCESS,
    FETCH_SUMMARY_FAILED,
    FETCH_SUMMARY_DETAIL_REQUEST,
    FETCH_SUMMARY_DETAIL_SUCCESS,
    FETCH_SUMMARY_DETAIL_FAILED,
    FETCH_AVAILABLE_INVOICE_REQUEST,
    FETCH_AVAILABLE_INVOICE_SUCCESS,
    FETCH_AVAILABLE_INVOICE_FAILED,
    DOWNLOAD_SIMPLE_EXCEL_REQUEST,
    DOWNLOAD_SIMPLE_EXCEL_SUCCESS,
    DOWNLOAD_SIMPLE_EXCEL_FAILED,
    DOWNLOAD_DETAIL_CSV_REQUEST,
    DOWNLOAD_DETAIL_CSV_SUCCESS,
    DOWNLOAD_DETAIL_CSV_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED
} from './mutation-type'

const getSummary = async ({ commit, state, getters, rootGetters }, { projectIdx, month }) => {
    commit(FETCH_SUMMARY_REQUEST)
    try {
        const { data, status } = await api.fetchSummary({ projectIdx, month }, rootGetters.requiredService)
        commit(FETCH_SUMMARY_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_FAILED, error)
        throw error
    }
}

const getSummaryDetail = async ({ commit, state, getters, rootGetters }, { projectIdx, month, productCode, region, date }) => {
    commit(FETCH_SUMMARY_DETAIL_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryDetail({ projectIdx, month, productCode, region, date }, rootGetters.requiredService)
        commit(FETCH_SUMMARY_DETAIL_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_DETAIL_FAILED, error)
        throw error
    }
}

const getAvailableInvoice = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(FETCH_AVAILABLE_INVOICE_REQUEST)
    try {
        const { data } = await billingPrimaryService.getAvailableInvoice({ usageAccountId, month }, rootGetters.requiredService)
        commit(FETCH_AVAILABLE_INVOICE_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_AVAILABLE_INVOICE_FAILED, error)
        throw error
    }
}

const downloadSimpleExcel = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(DOWNLOAD_SIMPLE_EXCEL_REQUEST)
    try {
        const { data } = await billingPrimaryService.simpleExcel({ usageAccountId, month }, rootGetters.requiredService)
        commit(DOWNLOAD_SIMPLE_EXCEL_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_SIMPLE_EXCEL_FAILED, error)
        throw error
    }
}

const downloadDetailCSV = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(DOWNLOAD_DETAIL_CSV_REQUEST)
    try {
        const { data } = await billingPrimaryService.detailCSV({ usageAccountId, month }, rootGetters.requiredService)
        commit(DOWNLOAD_DETAIL_CSV_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_DETAIL_CSV_FAILED, error)
        throw error
    }
}

const downloadInvoicePDF = async ({ commit, state, getters, rootGetters }, { usageAccountId, month, locale }) => {
    commit(DOWNLOAD_INVOICE_PDF_REQUEST)
    try {
        const { data } = await billingPrimaryService.invoicePDF({ usageAccountId, month, locale }, rootGetters.requiredService)
        commit(DOWNLOAD_INVOICE_PDF_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_INVOICE_PDF_FAILED)
        throw error
    }
}

export default {
    getSummary,
    getSummaryDetail,
    getAvailableInvoice,
    downloadSimpleExcel,
    downloadDetailCSV,
    downloadInvoicePDF
}
